import { styled } from '@mui/material';

export const ChatLayout = styled('div')`
  display: grid;
  grid-template-areas: 'chat-gap chat-conversation chat-widgets chat-widget-actions';
  grid-template-columns: 0 minmax(250px, 760px) 1fr 0;
  grid-template-rows: 1fr;
  overflow: hidden;

  &.chat-layout__multi-tool {
    padding: ${({ theme }) => theme.spacing(1.5)};
  }

  &.chat-layout__table-annotation {
    zoom: 0.8;
    padding-bottom: 8px;
  }

  &.chat-layout__home{
    padding: ${({ theme }) => theme.spacing(1.5)};
    width: 100%;
  }

  @media only screen and (min-width: 600px) {
      grid-template-columns: minmax(40px, 1fr) minmax(250px, 1200px) 1fr auto;

      &.chat-layout__home{
        padding: ${({ theme }) => theme.spacing(0)};
        grid-template-columns: minmax(40px, 1fr) minmax(250px, 850px) minmax(40px, 1fr) auto; 
      }

      &.chat-layout__multi-tool {
        padding: ${({ theme }) => theme.spacing(3)};
      }
    }
  }

  @media only screen and (min-width: 600px) {
    &.chat-layout--widgets-open {
      grid-template-columns: 0 minmax(250px, 500px) minmax(400px, 1fr) auto;
    }
  }
`;

export const ChatLayoutGap = styled('div')`
  grid-area: chat-gap;
`;

export const ChatLayoutConversation = styled('div')`
  grid-area: chat-conversation;
`;

export const ChatLayoutWidgets = styled('div')`
  grid-area: chat-widgets;

  &.chat-layout-widgets--share-page-spacing {
    margin-top: ${({ theme }) => theme.spacing(3)};
    margin-bottom: ${({ theme }) => theme.spacing(5)};
  }
`;

export const ChatLayoutWidgetActions = styled('div')`
  grid-area: chat-widget-actions;

  &.chat-layout-widget-actions--top-padding {
    margin-top: ${({ theme }) => theme.spacing(3)};
  }
`;
